import { Component } from 'react'
import PropTypes from 'prop-types'
import client from 'common/admin/client'

class DataProvider extends Component {
  state = {
    data: null,
    loaded: false
  }

  componentDidMount () {
    this.loadInitialData()
  }

  componentDidUpdate (prevProps) {
    if (this.props.url !== prevProps.url) {
      this.loadInitialData()
    }
  }

  async loadInitialData () {
    const { url } = this.props

    try {
      const data = await client.get(url)
      this.setState({ data, loaded: true })
    } catch (error) {
      this.setState({ error, loaded: true })
    }
  }

  render () {
    const { data, loaded, error } = this.state

    if (!loaded) {
      return null
    }

    if (error) {
      return this.props.error(error)
    } else {
      return this.props.render(data)
    }
  }
}

DataProvider.propTypes = {
  error: PropTypes.func.isRequired,
  render: PropTypes.func.isRequired,
  url: PropTypes.string.isRequired
}

export default DataProvider
